let bundleNumber = 6;
document.addEventListener('DOMContentLoaded', function() {
  if ( document.querySelector('.discount-item.active') ) {
    bundleNumber = Number(document.querySelector('.discount-item.active').getAttribute('data-bundle'));
  }
});

function setBundleText() {
  let count = 0
  document.querySelectorAll('bundle-variant input').forEach((variant) => {
    count += Number(variant.value)
  })
  const allBtn = document.querySelectorAll('bundle-variant:not(.disabled) .plus-btn')

  allBtn.forEach((item) => {
    if (count < bundleNumber) {
      item.classList.remove('disabled')
    } else {
      item.classList.add('disabled')
    }
  })

  if (count >= bundleNumber) {
    document.querySelector('.bundle-buy-btn .fulfill').classList.remove('hidden')
    document.querySelector('.bundle-buy-btn .unfulfilled').classList.add('hidden')
    document.querySelector('.bundle-buy-btn').classList.remove('disabled')
  } else {
    document.querySelector('.bundle-buy-btn').classList.add('disabled')
    document.querySelector('.bundle-buy-btn .fulfill').classList.add('hidden')
    document.querySelector('.bundle-buy-btn .unfulfilled').classList.remove('hidden')
    document.querySelectorAll('bundle-ring .number').forEach(item => item.innerHTML = `${bundleNumber - count}`)
  }
}

if (!customElements.get('bundle-ring')) {
  customElements.define('bundle-ring', class BundleRing extends HTMLElement {
    constructor() {
      super();
      setTimeout(() => {
        const allDiscount = this.querySelectorAll('.discount-item')
        allDiscount.forEach((discount) => {
          discount.addEventListener('click', (e) => {
            allDiscount.forEach((sub) => {
              sub.classList.remove('active')
            })

            let target = ''
            if (e.target.classList.contains('discount-item')) {
              target = e.target
            } else {
              target = e.target.closest('.discount-item')
            }

            target.classList.add('active')
            bundleNumber = Number(target.getAttribute('data-bundle'))
            this.querySelector('.number-total').innerHTML = bundleNumber

            this.querySelectorAll('input').forEach(item => {
              item.value = 0
            })
            setBundleText()
          })
        })

        this.querySelector('.bundle-buy-btn').addEventListener('click', (e) => {
          let target = ''
          if (e.target.classList.contains('bundle-buy-btn')) {
            target = e.target
          } else {
            target = e.target.closest('.bundle-buy-btn')
          }

          let reqBase = []
          this.querySelectorAll('input').forEach(item => {
            const value = Number(item.value);
            const title = item.getAttribute('data-title');
            const preorder = item.getAttribute('data-preorder');
            if (value > 0) {
              if (preorder) {
                reqBase.push({
                  id: item.getAttribute('data-id'),
                  quantity: value,
                  properties: {
                    "PreOrder": preorder
                  }
                })
              } else {
                reqBase.push({
                  id: item.getAttribute('data-id'),
                  quantity: value,
                  properties: {
                  }
                })
              }
            }
          })
          if (reqBase.length > 0) {
            target.classList.add('free-gift-loading')
            CartJS.addItems(reqBase, {
              success: () => {
                target.classList.remove('free-gift-loading')
              }
            })
          }
        })
      }, 200)
    }

  })
}

if (!customElements.get('bundle-variant')) {
  customElements.define('bundle-variant', class BundleVariant extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (e) => {
        try {
          /*
          document.querySelector("#product_media_mobile").innerHTML = this.querySelector('.media-wrapper').innerHTML
          document.querySelector("#product_thumbnails").innerHTML = this.querySelector('.thumbnails-wrapper').innerHTML
          if (document.querySelector('#slide3'))
            document.querySelector('#slide3').parentNode.removeChild(document.querySelector('#slide3'))
          window.reInitSwiper()
          */
          var value = this.getAttribute('data-value');
          document.querySelector('.swatch-element[data-value="'+value+'"]').click();
          document.querySelector('.swatch-element[data-value="'+value+'"] label').click();
        } catch (e) {
          console.error(e)
        }
      })

      setTimeout(() => {
        this.isDisabled = this.classList.contains('disabled')

        console.log('disabled', this.classList.contains('disabled'))
        this.querySelector('.plus-btn').addEventListener('click', (event) => {
          event.stopPropagation()

          if (this.isDisabled) {
            return
          }

          let allInputValue = 0
          const allInputs = document.querySelectorAll('bundle-ring input')
          allInputs.forEach(item => {
            allInputValue += Number(item.value) ?? 0
          })
          if (allInputValue < bundleNumber) {
            this.querySelector('input').stepUp(1)
          }
          setBundleText()
        })
        this.querySelector('.minus-btn').addEventListener('click', () => {
          if (this.isDisabled) {
            return
          }

          if (Number(this.querySelector('input').value) > 0)
            this.querySelector('input').stepDown(1)
          setBundleText()
        })
      }, 200)
    }

    isDisabled = false
  })
}
